module.exports = __webpack_public_path__ + "static/media/_fieldclick.81cba340.mp3";